module.exports = __webpack_public_path__ + "static/dilloway-fb75479cf997d2e85890d47c10722fc4.png";